import { FC } from 'react'
import { IoChevronForwardCircleOutline } from 'react-icons/io5'
import s from './ChevronForwardCircleOutline.module.scss'
export type ChevronForwardCircleOutlineProps = {} & React.ComponentProps<
  typeof IoChevronForwardCircleOutline
>
const ChevronForwardCircleOutline: FC<ChevronForwardCircleOutlineProps> = ({
  ...props
}) => {
  return <IoChevronForwardCircleOutline className={s.root} {...props} />
}

export default ChevronForwardCircleOutline
